import * as fromCoreContext from './core-context/core-context-reducer';
import * as fromMember from './member/member-reducer';
import * as fromOffers from './offers/offers-reducer';
import * as fromGames from './games/games-reducer';
import * as fromSpaycialIntegration from './spaycial-integration/spaycial-integration-reducer';
import { legalDocumentsReducer, LegalDocumentsState } from '@app/core/store/legal-documents/reducers';
import { programsReducer, ProgramsState } from '@app/core/store/programs/reducers';

export interface State {
  coreContext: fromCoreContext.State;
  member: fromMember.State;
  offers: fromOffers.State;
  games: fromGames.State;
  spaycialIntegration: fromSpaycialIntegration.State;
  legalDocuments: LegalDocumentsState;
  programs: ProgramsState;
}

export const reducers = {
  coreContext: fromCoreContext.reducer,
  member: fromMember.reducer,
  offers: fromOffers.reducer,
  games: fromGames.reducer,
  spaycialIntegration: fromSpaycialIntegration.reducer,
  legalDocuments: legalDocumentsReducer,
  programs: programsReducer
};

export function selectCoreContext(state: State): fromCoreContext.State {
  return state.coreContext;
}

export function selectMember(state: State): fromMember.State {
  return state.member;
}
